import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api, formatError } from "../lib/api";
import { toast } from "sonner";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", location: "", rating: 5, content: "" });
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/testimonials").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/testimonials", form);
      toast.success(data.message);
      setForm({ name: "", location: "", rating: 5, content: "" });
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-20 md:py-28 px-6 md:px-10 max-w-7xl mx-auto" data-testid="testimonials-page">
      <div className="overline mb-4">From The Community</div>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight">What Clients Say</h1>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((t) => (
          <article key={t.id} className="bg-[#0A0A0A] border border-white/5 p-8" data-testid={`testimonial-${t.id}`}>
            <div className="flex gap-1 text-[#D4AF37]">
              {Array.from({ length: t.rating }).map((_, i) => <Star key={i} size={14} fill="#D4AF37" stroke="#D4AF37" />)}
            </div>
            <p className="mt-5 text-white/80 font-serif text-lg leading-relaxed italic">"{t.content}"</p>
            <div className="mt-6 text-sm">
              <div className="font-medium">{t.name}</div>
              <div className="text-white/50 text-xs uppercase tracking-[0.18em] mt-1">{t.location}</div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-20 pt-12 border-t border-white/10" data-testid="testimonial-form-section">
        <div className="overline mb-3">Share Your Experience</div>
        <h2 className="font-serif text-3xl mb-8">Submit a Testimonial</h2>
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 max-w-3xl" data-testid="testimonial-form">
          <div>
            <label className="overline block mb-3">Name *</label>
            <input required value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} className="w-full bg-transparent border-b border-white/20 py-3 text-white focus:border-[#D4AF37] outline-none" data-testid="testimonial-name" />
          </div>
          <div>
            <label className="overline block mb-3">Location</label>
            <input value={form.location} onChange={(e)=>setForm({...form, location: e.target.value})} className="w-full bg-transparent border-b border-white/20 py-3 text-white focus:border-[#D4AF37] outline-none" data-testid="testimonial-location" />
          </div>
          <div className="md:col-span-2">
            <label className="overline block mb-3">Rating</label>
            <div className="flex gap-2">
              {[1,2,3,4,5].map((n) => (
                <button type="button" key={n} onClick={() => setForm({...form, rating: n})} className={`p-2 ${form.rating >= n ? "text-[#D4AF37]" : "text-white/30"}`} data-testid={`testimonial-rating-${n}`}>
                  <Star size={22} fill={form.rating >= n ? "#D4AF37" : "none"} />
                </button>
              ))}
            </div>
          </div>
          <div className="md:col-span-2">
            <label className="overline block mb-3">Your Experience *</label>
            <textarea required rows={5} value={form.content} onChange={(e)=>setForm({...form, content: e.target.value})} className="w-full bg-transparent border-b border-white/20 py-3 text-white focus:border-[#D4AF37] outline-none" data-testid="testimonial-content" />
          </div>
          <div className="md:col-span-2">
            <button type="submit" disabled={loading} className="bg-[#8B0000] hover:bg-[#A50000] text-white px-10 py-4 text-xs uppercase tracking-[0.2em]" data-testid="testimonial-submit-btn">
              {loading ? "Submitting…" : "Submit Testimonial"}
            </button>
            <p className="text-xs text-white/50 mt-3">Testimonials are reviewed before publication.</p>
          </div>
        </form>
      </div>
    </div>
  );
}
